import React from 'react'
import { Chip, makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import Text from '../../../../atoms/Text'
import Icon from '../../../../atoms/Icon'
import { TEXT_VARIANTS } from '../../../../../constants'
import Tooltip from '../../../../atoms/Tooltip'

const useStyle = makeStyles({
  chip: {
    justifyContent: 'flex-start',
    paddingLeft: '.5rem'
  }
})
const PermissionGroupSelectedPermissions = ({ pendingSelectList, canEditInternalPermissions, editing, unselectPermission }) => {
  const classes = useStyle()
  return (
    <div className='flex flex-col items-center w-full'>
      <div className='flex flex-col items-start w-full pb-2'>
        <div className='flex flex-row items-center gap-sm'>
          <Text text='Permissions' variant={TEXT_VARIANTS.h3} />
          {
            pendingSelectList?.length > 0 && (
              <Text text={`- ${pendingSelectList?.length}`} variant={TEXT_VARIANTS.h3} />
            )
          }
        </div>
        <Text> Add <strong>Permissions</strong> you'd like this group to include.</Text>
      </div>
      <div className='grid w-full gap-sm lg:grid-cols-3 md:grid-cols-2 grid-cols-1'>
        {pendingSelectList?.length === 0 ? (
          <div>
            <h3>No Permissions</h3>
          </div>
        ) : pendingSelectList?.map((item, index) => {
          return (
            <Chip
              key={index}
              size='small'
              icon={
                editing
                  ? !canEditInternalPermissions(item)
                    ? (
                      <Tooltip title='Internal Permission'>
                        <div><Icon name='lock' /></div>
                      </Tooltip>
                    )
                    : <Icon name='close' />
                  : undefined
              }
              label={item.name}
              color='primary'
              className={classes.chip}
              onClick={() => {
                editing && unselectPermission(item.permissionId)
              }}
              disabled={!editing}
            />
          )
        })}
      </div>
    </div>
  )
}

PermissionGroupSelectedPermissions.propTypes = {
  pendingSelectList: PropTypes.array,
  canEditInternalPermissions: PropTypes.func,
  editing: PropTypes.bool,
  unselectPermission: PropTypes.func
}

export default PermissionGroupSelectedPermissions
